<template>
	<section class="posts-grid" v-if="posts && posts.length" :class="'type-'+posts[0].type">
		
		<div class="posts-line" v-if="posts[0].type === 'post'">
            <PostBlock v-for="post in posts" :key="post.id" :data="post" />
        </div>

		<div class="venue-line" v-if="posts[0].type === 'venu'">
            <VenueBlock v-for="post in posts" :key="post.id" :post="post" />
        </div>

		<div class="venue-line" v-if="posts[0].type === 'events'">
            <EventBlock v-for="post in posts" :key="post.id" :post="post" />
        </div>

	</section>
</template>


<script>
import PostBlock from '@/components/elements/PostBlock'
import VenueBlock from '@/components/elements/VenueBlock'
import EventBlock from '@/components/elements/EventBlock'
import { mapGetters } from 'vuex'

export default {
    name: 'posts-grid',
    props: {
		posts :{
			default: []
		}
	},
	components:{
		PostBlock,
		VenueBlock,
		EventBlock
	},
	computed:{
		...mapGetters([
			'currentPostType',
		]),
	}
	
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.posts-grid{
	overflow: hidden;
	&.type-clinic{
		.posts-line{
			margin-left: 0;
			margin-right: 0;
			.block{
				width: 100%;
				max-width: 100%;
				padding-left: 0;
				padding-right: 0;
			}
		}
	}
}
.posts-line{
	display: flex;
	flex-wrap: wrap;
	margin-left: -25px;
	margin-right: -25px;
	min-width: 100%;
	.block{
		width: 33.33%;
		max-width: 33.33%;
		padding-left: 25px;
		padding-right: 25px;

	}
	@include mquery($tablet){

		margin-left: -15px;
		margin-right: -15px;
		.block{
			width: 50%;
			max-width: 50%;	
			padding-left: 15px;
			padding-right: 15px;
		}
	}
	@include mquery($phone){
		.block{
			width: 100%;
			max-width: 100%;
		}
	}
}
.posts-grid{
	.block{
		margin-bottom: 50px;
		@include mquery($tablet){
			margin-bottom: 30px;
		}
		@include mquery($phone){
			margin-bottom: 15px;
		}
	}
}
</style>